var map = {
	"./0/atlas-m.png": 1614,
	"./0/first-m.png": 4214,
	"./0/next-m.png": 7940,
	"./1/first-m.png": 2440,
	"./1/playboy-m.png": 8161,
	"./2/first-m.png": 8064,
	"./2/the_world_news-m.png": 8846,
	"./3/first-m.png": 5529,
	"./3/music_awards-m.png": 463,
	"./4/first-m.png": 5069,
	"./4/unn-m.png": 1307,
	"./5/first-m.png": 4415,
	"./5/sluhay-m.png": 7774
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9755;